import { CheckCircleOutlined } from '@ant-design/icons';
import React from 'react';
import { tran } from '../../../../translations/schema/TranslationSchema';
import { IWidgetType } from '../../../IWidgetType';
import { WidgetCategory, WidgetMainType, WidgetType } from '../../../Widget';
import { ConfirmWidgetConfigComponent } from './ConfirmWidgetConfigComponent';
import { ConfirmWidgetFormComponent } from './ConfirmWidgetFormComponent';
import { ConfirmWidgetPreviewComponent } from './ConfirmWidgetPreviewComponent';
import { ConfirmWidgetSchema } from './ConfirmWidgetSchema';
import { IConfirmWidget } from './IConfirmWidget';
import { createConfirmWidgetFormSchema } from './createConfirmWidgetFormSchema';
import { getConfirmWidgetReference } from './getConfirmWidgetReference';
import { ConfirmWidgetRequiredRule } from './rules/ConfirmWidgetRequired.rule';

export const ConfirmWidgetType: IWidgetType<IConfirmWidget> = {
  type: WidgetType.Confirm,
  mainType: WidgetMainType.Base,
  category: WidgetCategory.Advanced,
  name: 'Conferma',
  icon: <CheckCircleOutlined />,
  hasValue: true,
  getReference: getConfirmWidgetReference,
  createFormSchema: createConfirmWidgetFormSchema,
  formComponent: ConfirmWidgetFormComponent,
  previewComponent: ConfirmWidgetPreviewComponent,
  configValidator: ConfirmWidgetSchema,
  configComponent: ConfirmWidgetConfigComponent,
  translationSchema: tran.widget({
    layout: tran.object({
      confirmText: tran.string(),
      editText: tran.string(),
    }),
  }),
  rules: [],
  fixedRules: [ConfirmWidgetRequiredRule],
};
